import { Link } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'

export default function PageHeader({ title, subtitle, icon: Icon, breadcrumb }) {
  return (
    // 这里不要再加 px-*：内层 .container 已负责左右留白。原先外层 px-6 叠上去
    // 变成 48px，比下方卡片宽一倍，标题跟内容对不齐。
    <div className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-8">
      <div className="container">
        {/* 小屏条目多时要能换行，否则末级被挤出屏幕 */}
        <nav className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-white/80 mb-4">
          <Link to="/" className="hover:text-white">
            <FaHome />
          </Link>
          {breadcrumb?.map((item, index) => (
            <span key={index} className="flex items-center gap-2">
              <span>/</span>
              {item.path ? (
                <Link to={item.path} className="hover:text-white">
                  {item.label}
                </Link>
              ) : (
                <span>{item.label}</span>
              )}
            </span>
          ))}
        </nav>

        {/* Title */}
        <h1 className="text-fluid-2xl font-bold flex items-center gap-2 sm:gap-3 mb-2">
          {Icon && <Icon className="shrink-0 text-white/90" />}
          {title && <span className="text-white/90">{title}</span>}
        </h1>

        {subtitle && (
          <p className="text-fluid-base text-white/90">{subtitle}</p>
        )}
      </div>
    </div>
  )
}
